$(document).ready(function(){
  $('.gg-slider-for').slick({
    centerMode: true,
    slidesToShow: 3,
    focusOnSelect: true,
    centerPadding: '0px',
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000
  })
  
  $('.sort-per-page select.num').on('change', function(){
    window.location.replace(jQuery(this).val());
  });
  
  $('.gg-policies-tabs a').click( function(e) {
    var tabId = $(this).data('id');
    e.preventDefault();
    $('.gg-policies-tabs a').removeClass('active');
    $(this).addClass('active');
    $('.gg-policy-section').removeClass('active');
    $(`#${tabId}`).addClass('active');
  })
  
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('tab');
  
  if (myParam === 'terms') {
    $('.gg-policies-tabs a').removeClass('active');
    $(".gg-policies-tabs a[data-id='gg-terms']").addClass('active');
    $('.gg-policy-section').removeClass('active');
    $('#gg-terms').addClass('active');
  }
})